import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `whitespace-nowrap transition-colors hover:text-[#38bdf8] ${isActive ? "text-[#38bdf8]" : "text-slate-400"}`;

  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 border-b border-slate-800 bg-[#020617]/95 backdrop-blur-md"
    >
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <div className="w-8 h-8 rounded-lg bg-[#1d4ed8] border border-[#38bdf8]/40 flex items-center justify-center font-bold text-white font-mono-x text-sm">
            KX
          </div>
          <span className="font-bold text-xl tracking-wider text-white font-mono-x">KORANEX</span>
        </Link>

        <div className="hidden lg:flex items-center gap-5 text-[11px] font-mono-x uppercase tracking-widest">
          {NAV_LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} className={linkClass} data-testid={`nav-link-${link.to === "/" ? "accueil" : link.to.slice(1)}`} end={link.to === "/"}>
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-quote-button"
            className="hidden sm:inline-flex px-5 py-2.5 rounded-lg bg-[#1d4ed8] hover:bg-blue-600 text-white text-xs font-mono-x font-bold tracking-wider uppercase transition-colors shadow-lg shadow-blue-950 kx-glow kx-shine"
          >
            Demander un devis
          </Link>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-lg border border-slate-800 text-slate-300 hover:text-white hover:border-[#38bdf8]/50 transition-colors"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-slate-800 bg-[#020617] px-6 py-4">
          <div className="flex flex-col gap-1 text-sm font-mono-x uppercase tracking-widest">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`nav-mobile-link-${link.to === "/" ? "accueil" : link.to.slice(1)}`}
                onClick={() => setOpen(false)}
                className={`py-3 border-b border-slate-800/60 transition-colors ${
                  location.pathname === link.to ? "text-[#38bdf8]" : "text-slate-300 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="nav-mobile-quote-button"
              onClick={() => setOpen(false)}
              className="mt-4 mb-2 text-center px-5 py-3.5 rounded-lg bg-[#1d4ed8] hover:bg-blue-600 text-white font-bold transition-colors kx-glow"
            >
              Demander un devis gratuit
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
